export const DASHBOARD_QUERY_NAMESPACE = ["dashboard"];
